const types = {
    SHOW_CART: 'SHOW_CART',
    QUANTITY_IN_CART: 'QUANTITY_IN_CART',
    ADD_TO_CART: 'ADD_TO_CART',
    DELETE_PRODUCT_IN_CART: 'DELETE_PRODUCT_IN_CART',
    CHANGE_QUANTITY_IN_CART: 'CHANGE_QUANTITY_IN_CART',
    DELETE_ALL_PRODUCTS_IN_CART: 'DELETE_ALL_PRODUCTS_IN_CART',
};

export default types;